var React = require('react');

module.exports = React.createClass({
  render: function() {
    var baseProps = {
      'xmlnsSketch': 'http://www.bohemiancoding.com/sketch/ns',
'xmlnsRdf': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
'xmlns': 'http://www.w3.org/2000/svg',
'viewBox': '0 0 50 50',
'height': '20',
'width': '20',
'version': '1.1',
'xmlnsCc': 'http://creativecommons.org/ns#',
'xmlnsDc': 'http://purl.org/dc/elements/1.1/',
      className: 'svg-icon',
      dangerouslySetInnerHTML: {
        __html: " <title>8-magglass-search</title> <desc>Created with Sketch.</desc> <path d=\"m31.815 30.829c2.9066-3.1202 4.5553-7.1924 4.5553-11.513 0-9.3318-7.5899-16.922-16.922-16.922-9.3298 0-16.918 7.5899-16.918 16.922 0 9.3303 7.5884 16.921 16.918 16.921 4.1789 0 8.1273-1.5415 11.21-4.2786l-1.62-.0485 15.129 15.13c.36681.36681.85918.56594 1.3676.56594s1.0008-.19912 1.3676-.56594c.75559-.75559.75559-1.9806 0-2.7362l-15.116-15.117.02909 1.6423zm-1.7306-1.6121-.77801.83518.8071.8071 15.116 15.116c-.16807-.16807-.16807-.44058 0-.60864.08188-.08188.19295-.1268.30482-.1268s.22294.04491.30482.1268l-15.129-15.128-.788-.78834-.833.73985c-2.656 2.3579-6.048 3.6822-9.64 3.6822-8.0229 0-14.553-6.5313-14.553-14.556 0-8.0257 6.5291-14.557 14.553-14.557 8.0255 0 14.557 6.531 14.557 14.557 0 3.7139-1.4165 7.2126-3.9208 9.9009z\" sketch:type=\"MSShapeGroup\"/> ",
      }
    };
    var props = Object.assign({}, baseProps, this.props);
    return React.createElement('svg', props);
  },
});



// WEBPACK FOOTER //
// ./node_modules/dk-ui-lib/assets/search.svg